function calcolaConsegnaECountdown() {
    const oraAttuale = new Date();
    const giornoSettimana = oraAttuale.getDay();
    const oraLimite = new Date(oraAttuale.getFullYear(), oraAttuale.getMonth(), oraAttuale.getDate(), 17, 30, 0);
    const differenzaMs = oraLimite - oraAttuale;
    let messaggio;

    // Calcola ore e minuti mancanti al limite delle 17:30
    let oreMancanti = Math.floor(differenzaMs / 1000 / 60 / 60);
    let minutiMancanti = Math.floor((differenzaMs / 1000 / 60) % 60);
    let partiMessaggio = [];

    if (oreMancanti > 0) {
        partiMessaggio.push(`${oreMancanti} ore`);
    }
    partiMessaggio.push(`${minutiMancanti} minuti`);

    if (giornoSettimana >= 1 && giornoSettimana <= 4) {
        if (oraAttuale <= oraLimite) {
            messaggio = `Ordina entro ${partiMessaggio.join(' e ')} e parte oggi`;
        } else {
            messaggio = "Ordina ora e parte domani";
        }
    } else if (giornoSettimana === 5) {
        if (oraAttuale <= oraLimite) {
            messaggio = `Ordina entro ${partiMessaggio.join(' e ')} e parte oggi`;
        } else {
            messaggio = "Ordina ora e parte Lunedì";
        }
    } else {
        messaggio = "Ordina ora e parte Lunedì";
    }
    document.getElementById('messaggioConsegna').innerText = messaggio;
}

setInterval(calcolaConsegnaECountdown, 60000);
window.onload = calcolaConsegnaECountdown;
